import type { JSX } from 'react';
import { Align, type Alignment } from '../../core/model';
import './components.css';

const CELLS: readonly { value: Alignment; name: string }[] = [
  { value: Align.TOP | Align.LEFT, name: 'Top left' },
  { value: Align.TOP, name: 'Top centre' },
  { value: Align.TOP | Align.RIGHT, name: 'Top right' },
  { value: Align.LEFT, name: 'Centre left' },
  { value: Align.CENTER, name: 'Centre' },
  { value: Align.RIGHT, name: 'Centre right' },
  { value: Align.BOTTOM | Align.LEFT, name: 'Bottom left' },
  { value: Align.BOTTOM, name: 'Bottom centre' },
  { value: Align.BOTTOM | Align.RIGHT, name: 'Bottom right' },
];

export function alignmentName(value: Alignment): string {
  return CELLS.find((cell) => cell.value === value)?.name ?? 'Custom';
}

/** 3 x 3 grid choosing which point of a box an alignment refers to. */
export function AlignmentPicker(props: { value: Alignment; onChange(value: Alignment): void; label: string }): JSX.Element {
  return (
    <div className="ui-align-picker" role="radiogroup" aria-label={props.label}>
      {CELLS.map((cell) => (
        <button
          key={cell.value}
          type="button"
          role="radio"
          aria-checked={props.value === cell.value}
          aria-label={cell.name}
          title={cell.name}
          onClick={() => props.onChange(cell.value)}
        />
      ))}
    </div>
  );
}
